module.exports = __webpack_public_path__ + "img/shoulder-ectomorph-male.4bdef250.svg";